import NextImage, { ImageProps as NextImageProps } from 'next/image';

export type ImageProps = NextImageProps;
export const Image: React.FC<ImageProps> = (props) => <NextImage {...props} />;
